import CityPageTemplate from "../city-template/CityPageTemplate";
import { huberHeightsConfig } from "./data";

export default function HuberHeightsPage() {
  return <CityPageTemplate config={huberHeightsConfig} />;
}